import { Component, Input, HostBinding, Optional, Self, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, NgControl } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { Subject } from 'rxjs';
import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

export class SplitNumber{
  constructor(public number1:string, public num1PostFix:string, 
    public number2:string, public num2PostFix:string){

    }
}
@Component({
  selector: 'material-split-number',
  templateUrl: './material-split-number.component.html',
  styleUrls: ['./material-split-number.component.css'],
  providers:[
    {
      provide:MatFormFieldControl, useExisting: MaterialSplitNumberComponent
    }
  ]
})
export class MaterialSplitNumberComponent implements MatFormFieldControl<SplitNumber>, OnDestroy {
  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  errorState = false;
  controlType = 'split-num-input';
  private _required = false;
  private _placeholder: string;
  private _disabled = false;


  splitNumber:SplitNumber;

  @HostBinding() id = 'split-num-'+(MaterialSplitNumberComponent.nextId++)+'\'';
  @HostBinding('class.floating')
  get shouldLabelFloat(){
    return this.focused || !this.empty;
  }
  @HostBinding('attr.aria-describedby') describedBy = '';

  setDescribedByIds(ids:string[]){
    this.describedBy = ids.join(' ');
  }

  @Input() 
  get value():SplitNumber | null{
    let n = this.parts.value;
    return new SplitNumber(n.firstNum,n.firstNumPostfix,n.secondNum,n.secondNumPostfix);
  }
  set value(nums:SplitNumber | null){
    this.splitNumber = nums;
    nums = nums || new SplitNumber(null,'MINR',null,'%');
    this.parts.setValue({
                          firstNum: (nums.number1? nums.number1 : ''),
                          firstNumPostfix:nums.num1PostFix,
                          secondNum:(nums.number2? nums.number2 : ''),
                          secondNumPostfix:nums.num2PostFix
                        });
    this.stateChanges.next();
  }

  @Input()
  get placeholder(){
    return this._placeholder;
  }
  set placeholder(plh){
    this._placeholder = plh;
    this.stateChanges.next();
  }

  @Input()
  get required(){
    return this._required;
  }
  set required(req){
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  @Input()
  get disabled(){
    return this._disabled;
  }
  set disabled(dis){
    this._disabled = coerceBooleanProperty(dis);
    this.stateChanges.next();
  }

  @Output() number1Changed:EventEmitter<string> = new EventEmitter();
  @Output() number2Changed:EventEmitter<string> = new EventEmitter();
  
  onContainerClick(event:MouseEvent){
    // if((event.target as Element).tagName.toLowerCase() != 'input'){
    //   this.elRef.nativeElement.querySelector('input').focus();
    // }
  }

  get empty(){
    return false;
    // let n = this.parts.value;
    // return !n.firstNum && !n.secondNum;
  }

  constructor(fb: UntypedFormBuilder, private fm:FocusMonitor, private elRef:ElementRef<HTMLElement>, 
              @Optional() @Self() public ngControl: NgControl) {
      this.parts = fb.group({
        'firstNum':null,
        'firstNumPostfix':'MINR',
        'secondNum':null,
        'secondNumPostfix':'%'
      });

      fm.monitor(elRef.nativeElement, true).subscribe(origin => {
        this.focused = !!origin;
        this.stateChanges.next();
      });

      // if(this.ngControl != null){
      //   this.ngControl.valueAccessor = this;
      // }
   }

   firstNumChanged(_evnt){
     if(this.number1Changed){
        this.number1Changed.emit(_evnt.target.value);
        this.stateChanges.next();
     }
   }
   secondNumChanged(_evnt){
    if(this.number2Changed){
        this.number2Changed.emit(_evnt.target.value);
        this.stateChanges.next();
    }
   }

   ngOnDestroy(){
     this.fm.stopMonitoring(this.elRef.nativeElement);
   }
}
